export default __webpack_public_path__ + "c669d1264c71823c2ca93774603c4e1c.jpg";